import { ISelectOption } from '@crm-framework/types';

import { managerOptionsSorting } from '@crm-package/dashboard';

import { DICTIONARY_EMPTY_VALUE_ID } from '../consts';

export const getRoutePathForLeadTab = (
  pagePath: string,
  id: string | number = ':id'
) => `/${id}${pagePath}`;

export function getDisplayedNameOf(lead?: any) {
  if (!lead) return 'no displayed name';

  const { firstName, lastName, fullName, email } = lead;

  if (fullName) return fullName;

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) return firstName;

  if (lastName) return lastName;

  return email || 'no displayed name';
}

export const managerSelectOptionsSorting = (
  prevItem: ISelectOption,
  item: ISelectOption
) => {
  if (prevItem.value === DICTIONARY_EMPTY_VALUE_ID) return -1;

  if (item.value === DICTIONARY_EMPTY_VALUE_ID) return 1;

  return managerOptionsSorting(prevItem, item);
};

export const getValueAppearance = (isCompleted: boolean) =>
  isCompleted ? 'success' : 'warning';

export const getValueText = (isCompleted: boolean) =>
  isCompleted ? 'Yes' : 'No';
